export default "__VITE_ASSET__bxRVG7JB__"